
import {
  Vue, Component, Prop, Ref,
} from 'vue-property-decorator';
import { requiredRules } from '@/features/common/helpers/validationRules';
import { VForm } from '@/features/common/types';

const CURRENCY_OPTIONS = ['USD', 'CAD', 'EUR', 'GBP', 'MXN'];

@Component
export default class FedExInvoiceStep extends Vue {
  @Ref('form') form!: VForm;

  @Prop({ default: false }) loading!: boolean;

  private requiredRules = requiredRules;

  private invoiceNumber = '';

  private invoiceDate = '';

  private invoiceAmount = '';

  private currency = 'USD';

  private dateMenu = false;

  private currencyOptions = CURRENCY_OPTIONS;

  // eslint-disable-next-line class-methods-use-this
  get todayDate(): string {
    return new Date().toISOString().substring(0, 10);
  }

  private onKeypressDecimal(event: KeyboardEvent): void {
    if (!/[\d.]/.test(event.key)) {
      event.preventDefault();
    }
    if (event.key === '.' && this.invoiceAmount.includes('.')) {
      event.preventDefault();
    }
  }

  private onSubmit(): void {
    if (!this.form.validate()) return;
    this.$emit('submit', {
      invoiceNumber: this.invoiceNumber,
      invoiceDate: this.invoiceDate,
      invoiceAmount: this.invoiceAmount,
      currency: this.currency,
    });
  }
}
